import { render, staticRenderFns } from "./TncJomBantu.vue?vue&type=template&id=9ef55f2c&"
import script from "./TncJomBantu.vue?vue&type=script&lang=js&"
export * from "./TncJomBantu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports